import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "disabled-cl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_input, {
      value: _ctx.inputValue,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      placeholder: _ctx.placeholder,
      maxlength: +_ctx.maxLength,
      "allow-clear": "",
      class: "fw",
      onBlur: _ctx.onBlur,
      onChange: _ctx.onChange,
      "addon-after": _ctx.addonAfter,
      disabled: _ctx.disabled
    }, null, 8, ["value", "placeholder", "maxlength", "onBlur", "onChange", "addon-after", "disabled"]),
    (_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}